import { useState } from 'preact/hooks'

const useForceRefresh = () => {
  const [refreshDependence, setForceRefreshNumber] = useState(0)
  const refresh = () => setForceRefreshNumber(Math.random())
  return { refreshDependence, refresh }
}

export default useForceRefresh
